import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import BottomNavigation from './components/BottomNavigation';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import ProductCustomize from './pages/ProductCustomize';
import CategoryShowcase from './pages/CategoryShowcase';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderComplete from './pages/OrderComplete';
import Orders from './pages/Orders';
import Likes from './pages/Likes';
import Contact from './pages/Contact';
import WirelessKeyboard from './pages/ProductDetails/WirelessKeyboard';
import NintendoJoyconPikachu from './pages/ProductDetails/NintendoJoyconPikachu';
import GamingHeadset from './pages/ProductDetails/GamingHeadset';
import Switch4in1Charger from './pages/ProductDetails/Switch4in1Charger';
import AromatherapyDiffuser from './pages/ProductDetails/AromatherapyDiffuser';
import EssentialOilSet from './pages/ProductDetails/EssentialOilSet';
import HDMICable from './pages/ProductDetails/HDMICable';
import LEDCurtainLight from './pages/ProductDetails/LEDCurtainLight';
import LEDLight500 from './pages/ProductDetails/LEDLight500';
import SUIP400Gameboy from './pages/ProductDetails/SUIP400Gameboy';
import RGBGamingMousePad from './pages/ProductDetails/RGBGamingMousePad';
import SwitchACAdapter from './pages/ProductDetails/SwitchACAdapter';
import Switch2ChargerDock from './pages/ProductDetails/Switch2ChargerDock';
import Switch2PortableStorageBag from './pages/ProductDetails/Switch2PortableStorageBag';
import Switch2ProtectScreen from './pages/ProductDetails/Switch2ProtectScreen';
import Switch2WristStrip from './pages/ProductDetails/Switch2WristStrip';
import SwitchMouseBase from './pages/ProductDetails/SwitchMouseBase';
import SwitchProController from './pages/ProductDetails/SwitchProController';
import SwitchProControllerDeluxe from './pages/ProductDetails/SwitchProControllerDeluxe';
import X7MGameboy from './pages/ProductDetails/X7MGameboy';
import LavaLamp from './pages/ProductDetails/LavaLamp';
import KaraokeSpeakerAndMic from './pages/ProductDetails/KaraokeSpeakerAndMic';

// Additional pages
import About from './pages/About';
import Warranty from './pages/Warranty';
import Returns from './pages/Returns';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Legal from './pages/Legal';
import Support from './pages/Support';
import NotFound from './pages/NotFound';

function App() {
  return (
    <CartProvider>
      <Router>
        <div className="App min-h-screen bg-dark-400 text-white">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:categoryId" element={<CategoryShowcase />} />
              <Route path="/product/1" element={<NintendoJoyconPikachu />} />
              <Route path="/product/2" element={<Switch4in1Charger />} />
              <Route path="/product/18" element={<AromatherapyDiffuser />} />
              <Route path="/product/19" element={<EssentialOilSet />} />
              <Route path="/product/15" element={<SUIP400Gameboy />} />
              <Route path="/product/21" element={<LEDLight500 />} />
              <Route path="/product/22" element={<LEDCurtainLight />} />
              <Route path="/product/24" element={<HDMICable />} />
              <Route path="/product/14" element={<RGBGamingMousePad />} />
              <Route path="/product/5" element={<SwitchACAdapter />} />
              <Route path="/product/6" element={<Switch2ChargerDock />} />
              <Route path="/product/9" element={<Switch2PortableStorageBag />} />
              <Route path="/product/10" element={<Switch2ProtectScreen />} />
              <Route path="/product/3" element={<SwitchMouseBase />} />
              <Route path="/product/4" element={<Switch2WristStrip />} />
              <Route path="/product/7" element={<SwitchProController />} />
              <Route path="/product/8" element={<SwitchProControllerDeluxe />} />
              <Route path="/product/16" element={<X7MGameboy />} />
              <Route path="/product/17" element={<LavaLamp />} />
              <Route path="/product/11" element={<WirelessKeyboard />} />
              <Route path="/product/25" element={<KaraokeSpeakerAndMic />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/customize/:id" element={<ProductCustomize />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-complete" element={<OrderComplete />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/likes" element={<Likes />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/warranty" element={<Warranty />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/support" element={<Support />} />
              <Route path="/products/wireless-keyboard" element={<WirelessKeyboard />} />
              <Route path="/products/nintendo-joycon-pikachu" element={<NintendoJoyconPikachu />} />
              <Route path="/products/gaming-headset" element={<GamingHeadset />} />
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <BottomNavigation />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
